"use strict";

const selectorDefault = {
  country: '[name="address[country]"]',
  zipCode: '[name="address[zip]"]',
  city: '[name="address[city]"]',
  province: '[name="address[province]"]',
  address01: '[name="address[address1]"]',
  address02: '[name="address[address2]"]',
  firstName: '[name="address[first_name]"]',
  lastName: '[name="address[last_name]"]',
  // firstNameKana: '[name="address[first_name_kana]"]',
  // lastNameKana: '[name="address[last_name_kana]"]',
  phone: '[name="address[phone]"]',
  form: "form",
  buttonEdit: null,
  buttonSubmit: null,
  buttonCheckoutEdit: "#checkout_shipping_address_id",
  furiganaForm: null,
};

const japanPostalCodeMessage = {
  japanAddressRequired: "入力されていません。",
  addressExists: "住所が正しくありません",
  addressTownExists: "郵便番号に基づいた住所をご登録ください。ご入力いただいた住所の表記を再度ご確認ください。例）〇 三番町 × 3番町",
  zipCodeInvalid: "郵便番号が正しくありません",
};

class JapanPostalCode {
  constructor(
    selectors,
    options = { name: null, messages: japanPostalCodeMessage }
  ) {
    // Configs
    this.apiKey = "5bbcded166dca5ddd717433ec61a86670e36783a";
    this.countryAvailable = ["Japan", "JP"];

    // Initialization
    this.zipCode = null;
    this.addressData = {};
    this.addressDataValidate = [];
    this.selectors = selectors;
    this.options = options;
    this.elements = this._getElements();

    if (
      this.options.name === "checkout" &&
      Shopify.Checkout &&
      Shopify.Checkout.step !== "contact_information"
    ) {
      return;
    }
    // Content Loaded
    if (this.elements.container && this.elements.country) {
      this._setupEventListeners();

      if(this.options.name === "register"){
        window.addEventListener('load', () => {
          // Load ZipCode Status
          this._initZipCodeFill();
          })
      }else{
        this._initZipCodeFill();
      }
    }
  }

  _getElements() {
    try {
      const container = document.querySelector(this.selectors.container);
      const form = container.querySelector(
        this.selectors.form || selectorDefault.form
      );

      return {
        container,
        form,
        country: container.querySelector(
          this.selectors.country || selectorDefault.country
        ),
        zipCode: container.querySelector(
          this.selectors.zipCode || selectorDefault.zipCode
        ),
        city: container.querySelector(
          this.selectors.city || selectorDefault.city
        ),
        province: container.querySelector(
          this.selectors.province || selectorDefault.province
        ),
        address01: container.querySelector(
          this.selectors.address01 || selectorDefault.address01
        ),
        address02: container.querySelector(
          this.selectors.address02 || selectorDefault.address02
        ),
        firstName: container.querySelector(
          this.selectors.firstName || selectorDefault.firstName
        ),
        lastName: container.querySelector(
          this.selectors.lastName || selectorDefault.lastName
        ),
        firstNameKana: container.querySelector(
          this.selectors.firstNameKana || selectorDefault.firstNameKana
        ),
        lastNameKana: container.querySelector(
          this.selectors.lastNameKana || selectorDefault.lastNameKana
        ),
        phone: container.querySelector(
          this.selectors.phone || selectorDefault.phone
        ),
        fields: form.querySelectorAll("input, select"),
      };
    } catch (e) {
      return {};
    }
  }

  _setupEventListeners() {
    this._setupEventForCountry();
    this._setupEventForZipCode();
    this._setupEventForFormSubmit();
  }

  _setupEventForFormSubmit() {
    this.elements.form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const thisButton = document.querySelector(this.selectors.buttonSubmit);
      if (this.options.name === "addresses") {
        btnLoading(thisButton);
        await this._validateForAddresses();
      } else if (this.options.name === "checkout") {
        let lang = WOVN.io.getCurrentLang().code;
        if(lang == 'ja'){
          await this._validateForCheckout();
        }
      }else if(this.options.name === "register"){
        this._validateForRegister(e);
      }

      if(this.options.name === "checkout"){
        ISSEYMIYAKE.validation.fieldCheck(this.elements.form.querySelector(this.selectors.firstName))
        ISSEYMIYAKE.validation.fieldCheck(this.elements.form.querySelector(this.selectors.lastName))
        // ISSEYMIYAKE.validation.fieldCheck(this.elements.form.querySelector(this.selectors.firstNameKana))
        // ISSEYMIYAKE.validation.fieldCheck(this.elements.form.querySelector(this.selectors.lastNameKana))
        document.querySelector('input[data-backup="phone"]').value = document.querySelector('input[data-backup="phone"]').value.replaceAll('-', '').trim()
      }
      
      let error = this.elements.form.querySelectorAll(".validation-error");
      if(this.options.name !== "register"){
        if (error.length === 0) {
          // if(this.options.name === "addresses"){
          //   let last_kana = this.elements.form.querySelector(this.selectors.lastNameKana).value;
          //   let first_kana = this.elements.form.querySelector(this.selectors.firstNameKana).value;
          //   let last_name = this.elements.form.querySelector(this.selectors.lastName).value;
          //   let first_name = this.elements.form.querySelector(this.selectors.firstName).value;
          //   this.elements.form.querySelector('input[name="address[last_name]"]').value = `${last_kana} ${first_kana}`;
          //   this.elements.form.querySelector('input[name="address[first_name]"]').value = `${last_name} ${first_name}`;
          // }
          this.elements.form.submit();
        } else {
          let submitButton = document.querySelector("#continue_button");
          if (submitButton) {
            setTimeout(() => {
              submitButton.classList.remove("btn--loading");
              submitButton.removeAttribute("disabled");
            }, 500);
          }
          this._displayError(thisButton);
          if (this.options.name === "addresses") {
            btnStopLoading(thisButton);
          }
        }
      }
    });
  }

  _validateForCheckout() {
    const fields = [
      this.elements.address01,
      this.elements.city,
      this.elements.province,
    ];

    // Remove all errors
    fields.forEach(async (field) => {
      await this._removeError(field);
    });

    let isFormValid =
      this.elements.lastName.value !== "" &&
      this.elements.zipCode.value !== "" &&
      this.elements.city.value !== "" &&
      this.elements.phone.value !== "" &&
      this.elements.address01.value !== "" &&
      this._isCountryAvailable();
    if (isFormValid) {
      // Validate address
      if (this._checkZipCodeValid(this.elements.zipCode.value)) {
        //province
        let provinceValue = this.elements.province.querySelector(
          `option[value=${this.elements.province.value}]`
        );
        this._findNewAddressData(provinceValue.textContent, this.elements.province, null, "prefecture");

        // set
        var address = this.elements.city.value + this.elements.address01.value;
        var flg_set = this._findNewAddressData(address, this.elements.address01, provinceValue.textContent, "set");

        //city
        if(flg_set == false){
          var city = this.elements.city.value;
          this._findNewAddressData(city, this.elements.city, provinceValue.textContent, "city");
        }
        
      }
    }
  }

  _validateForRegister(e = null) {
    this._hiddenError();

    let isFormValid =
      this.elements.zipCode.value !== "" &&
      this.elements.city.value !== "" &&
      this.elements.address01.value !== "" &&
      this._isCountryAvailable();
    if (isFormValid) {
      if (this._checkZipCodeValid(this.elements.zipCode.value)) {

        //province
        var province = this.elements.province.value;
        var flg = this._findNewAddressData(province, this.elements.province, null, "prefecture", true);
        if(flg == false){
          e.stopImmediatePropagation();
        }

        // set
        var address = this.elements.city.value + this.elements.address01.value;
        var flg_set = this._findNewAddressData(address, this.elements.address01, province, "set", true);

        //city
        if(flg_set == false){
          var city = this.elements.city.value;
          this._findNewAddressData(city, this.elements.city, province, "city", true);
          e.stopImmediatePropagation();     
        }

      }
    }
  }

  _validateForAddresses() {
    const fieldRequired = [
      this.elements.lastName ? this.elements.lastName.name : null,
      this.elements.firstName ? this.elements.firstName.name : null,
      // this.elements.lastNameKana.name,
      // this.elements.firstNameKana.name,
      this.elements.zipCode.name,
      this.elements.address01.name,
      this.elements.city.name,
      this.elements.phone.name,
      this.elements.province.name,
    ];
    let thisButton = document.querySelector(this.selectors.buttonSubmit);
    let lang = WOVN.io.getCurrentLang().code;
    
    this.elements.fields.forEach(async (field) => {
      await this._removeError(field);

      if (
        !this._isCountryAvailable() ||
        !fieldRequired.includes(field.name) ||
        field.classList.contains("visually-hidden")
      )
        return true;

      // Validate field
      // if (field.value === "" || !field) {
      //   if(lang == 'ja' || (lang != 'ja' && (field.name != this.elements.lastNameKana.name && field.name != this.elements.firstNameKana.name))){
      //     this._displayError(thisButton);
      //     this._addError(field, this.options.messages.japanAddressRequired);
      //     return false;
      //   }else if(lang != 'ja' && (field.name == this.elements.lastNameKana.name || field.name == this.elements.firstNameKana.name)){
      //     this._removeError(field);
      //   }
      // }

      // const regex = /^[\u30A0-\u30FF]+$/;
      // if(this.options.name === "addresses" && lang == 'ja' &&
      // (field.name === this.elements.lastNameKana.name || 
      //   field.name === this.elements.firstNameKana.name)){
      //     if(regex.test(field.value) == false){
      //       this._displayError(thisButton);
      //       this._addError(field, "カタカナで入力してください");
      //       return false;
      //     }
      // }

      // Validate zipCode
      if (
        field.value &&
        field.name === this.elements.zipCode.name &&
        !this._checkZipCodeValid(field.value)
      ) {
        this._displayError(thisButton);
        this._addError(field, this.options.messages.zipCodeInvalid);
        return false;
      }
    });

    // Validate address
    if (this._checkZipCodeValid(this.elements.zipCode.value)) {
      //province
      let provinceValue = this.elements.province.querySelector(
        `option[value=${this.elements.province.value}]`
      );
      this._findNewAddressData(provinceValue.textContent, this.elements.province, null, "prefecture");
      
      // set
      var address = this.elements.city.value + this.elements.address01.value;
      var flg_set = this._findNewAddressData(address, this.elements.address01, provinceValue.textContent, "set");

      //city
      if(flg_set == false){
        var city = this.elements.city.value;
        this._findNewAddressData(city, this.elements.city, provinceValue.textContent, "city");
      }
    }

    //国が選択されているか
    let country = this.elements.country;
    if(this.elements.country.value == '---'){
      this._addError(country, this.options.messages.japanAddressRequired);
      return false;
    }

    return true;
  }

  _validateAddress(field) {
    let provinceValue = this.elements.province.querySelector(
      `option[value=${this.elements.province.value}]`
    );
    if (
      field.name === this.elements.province.name &&
      !this._findAddressData(provinceValue.textContent, "prefecture")
    ) {
      this._addError(field, this.options.messages.addressExists);
      return false;
    }

    if (
      field.name === this.elements.city.name &&
      !this._findAddressData(field.value, "city")
    ) {
      this._addError(field, this.options.messages.addressExists);
      return false;
    }

    if (
      field.name === this.elements.address01.name &&
      !this._findAddressData(field.value, "town")
    ) {
      this._addError(field, this.options.messages.addressTownExists);
      return false;
    }
  }

  /**
   * @param string value
   * @param string addressCheck
   */
  _findAddressData(value, addressCheck) {
    //ケンオールが何も戻さなかった場合は、trueにする
    if(this.addressDataValidate.length <= 0)return true;
    //住所1は複数返却される可能性がある
    if(addressCheck == "town"){
      return this.addressDataValidate.find((item) => {
        return item[addressCheck] && value.indexOf(item[addressCheck]) === 0;
      });
    }else{
      return this.addressDataValidate.find((item) => {
        return item[addressCheck] && item[addressCheck] === value;
      });
    }
  }

    /**
   * @param string value
   * @param string field
   * @param boolean is_province
   */
    _findNewAddressData(value, field, provinceValue = null, addressCheck, is_register = false) {
      //ケンオールが何も戻さなかった場合は、trueにする
      if(this.addressDataValidate.length <= 0)return true;
      //住所1は複数返却される可能性がある
      var is_correct = false;
      if(addressCheck == "prefecture"){
        var is_correct = this.addressDataValidate.find((item) => {
          return item['prefecture'] && item['prefecture'] === value;
        });
      } else if(addressCheck == "set"){
        this.addressDataValidate.forEach(function(item){
          var address = item['city'] + item['town'];          
          if(item['prefecture'] == provinceValue && value.indexOf(address) == 0){
            is_correct = true;
          }
        });
      }else if(addressCheck == "city"){
        this.addressDataValidate.forEach(function(item){
          var address = item['city'] + item['town'];
          if(item['prefecture'] == provinceValue && address.indexOf(value) == 0){
            is_correct = true;
          }
        })
      }
      if(is_register){
        if(!is_correct){
          if(addressCheck == "prefecture" || addressCheck == "city"){
            this._visibleError(field, this.options.messages.addressExists);
            return false;
          }else{
            this._visibleError(field, this.options.messages.addressTownExists);
            return false;
          }
        }
      }else{
        if(!is_correct){
          if(addressCheck == "prefecture" || addressCheck == "city"){
            this._addError(field, this.options.messages.addressExists);
            return false;
          }else{
            this._addError(field, this.options.messages.addressTownExists);
            return false;
          }
        }
      }
    }

  _addError(element, message) {
    let error = document.createElement("div");
    error.classList.add("error-message");
    error.role = "alert";
    error.textContent = message;
    if(element.classList != undefined){
      element.classList.add("validation-error");
    }
    if(element.parentNode){
      element.parentNode.insertBefore(error, element.nextSibling);
    }
    // insert errorClass in parentElement
    if (element.parentElement) {
      element.parentElement.classList.add("validation-error-wrapper");
    }
  }

  _visibleError(element, message) {
    displayErrorMessage(element, message);
    let errorMessage = document.getElementById('error_message');
    errorMessage.innerText = '入力内容に不備があります';
    errorMessage.style.display = "block";
  }

  _removeError(element) {
    if (element.parentElement) {
      let elementParent = element.parentElement.querySelector(
        ".error-message"
      );

      elementParent && elementParent.remove();
    }

    element.classList.remove("validation-error");
  }

  _hiddenError() {
    let elementAll = document.querySelectorAll(`.error-message`);
    elementAll.forEach(function(ele){
      ele.style.display = 'none';
    })
  }

  _setupEventForCountry() {
    this.elements.country.addEventListener("change", () => {
      // re-load Validate
      if(this.options.name === "register"){
        this._validateForRegister();
      }else{
        this._validateForAddresses();
      }
      this._handleAddressAutoFill();
    });
  }

  _initZipCodeFill() {
    if (this.options.name === "checkout") {
      this._initZipCodeFillCheckout();
    } else if(this.options.name === "register"){
      this._handleLoadZipCodeStatus();
    }else {
      this._initZipCodeFillAddress();
    }
  }

  _initZipCodeFillCheckout() {
    this._handleLoadZipCodeStatus();

    let buttonEditElement = document.querySelector(
      this.selectors.buttonCheckoutEdit || selectorDefault.buttonCheckoutEdit
    );

    if (buttonEditElement) {
      buttonEditElement.addEventListener("change", () => {
        setTimeout(() => {
          this._handleLoadZipCodeStatus();
          this.zipCode = null;
        }, 200);
      });
    }
  }

  _initZipCodeFillAddress() {
    if (
      typeof this.selectors.buttonEdit !== "undefined" &&
      this.selectors.buttonEdit
    ) {
      let buttonEditElement = document.querySelector(this.selectors.buttonEdit);

      if (buttonEditElement) {
        buttonEditElement.addEventListener("click", () => {
          this._handleLoadZipCodeStatus();
          // if(this.options.name === "addresses"){
          //   let furigana = document.querySelector(this.selectors.furiganaForm);
          //   this._furiganaDisplay(furigana, this.elements.firstNameKana, this.elements.lastNameKana);
          // }
        });
      }
    }
  }

  _setupEventForZipCode() {
    ["keypress", "input"].forEach((event) => {
      this.elements.zipCode.addEventListener(event, () => {
        this._handleAddressAutoFill();
      });
    });
  }

  /**
   * @param value
   * @returns {boolean}
   */
  _checkZipCodeValid(value) {
    return /^〒?[0-9]{3}-?[0-9]{4}$/g.test(value);
  }

  _handleLoadZipCodeStatus() {
    if (this.elements.zipCode.value !== "") {
      const zipCode = this._toZipCodeString(this.elements.zipCode.value);
      const zipCodeIsValid = this._checkZipCodeValid(zipCode);

      if(!zipCodeIsValid){
        this._addError(this.elements, this.options.messages.addressExists);
        return false;
      }

      if (zipCodeIsValid && zipCode !== this.zipCode) {
        this._callAutoFillZipCodeApi(zipCode)
          .then((response) => response.json())
          .then(({ data }) => {
            this.zipCode = zipCode;
            this.addressDataValidate = data;
          });
      }
    }
  }

  _setupPrefectures() {
    let prefectures = [];

    if (this._isCountryAvailable()) {
      let elementProvinceSelected = this.elements.country.selectedOptions[0];
      if (
        elementProvinceSelected &&
        elementProvinceSelected.getAttribute("data-provinces")
      ) {
        prefectures = JSON.parse(
          elementProvinceSelected.getAttribute("data-provinces")
        );
      } else if (this.options.name === "checkout" || this.options.name === "register") {
        let elementProvinceOptions =
          this.elements.province.querySelectorAll("option");

        elementProvinceOptions.forEach((prefecture) => {
          let prefectureData = JSON.parse(
            prefecture.getAttribute("data-alternate-values")
          );

          if (prefectureData && prefectureData[0]) {
            prefectures.push([
              prefectureData[0],
              prefecture.text,
              prefecture.value,
            ]);
          }
        });
      }
    }

    this.prefectures = prefectures;
  }

  _isCountryAvailable = () => {
    return this.countryAvailable.includes(this.elements.country.value);
  };

  _handleAddressAutoFill = () => {
    if (this._isCountryAvailable()) {
      const zipCode = this._toZipCodeString(this.elements.zipCode.value);
      const zipCodeIsValid = this._checkZipCodeValid(zipCode);

      if (zipCodeIsValid) {
        // Checking the cache status
        if (this.zipCode !== zipCode) {
          this._setupPrefectures();
          this._callAutoFillZipCodeApi(zipCode)
            .then((response) => response.json())
            .then(({ data }) => {
              this.addressDataValidate = data;

              if (typeof data[0] !== "undefined") {
                this._handleFillAddressData(data[0]);
                this.addressData = data[0];
              }

              // re-check Validate
              if (this.options.name === "addresses") {
                this._validateForAddresses();
              }
            })
            .finally(() => {
              this.zipCode = zipCode;
            })
            .catch((error) => {
              //console.log("通信に失敗しました。", error);
            });
        } else if (this.addressData) {
          this._handleFillAddressData(this.addressData);
        }
      }
    }
  };

  _handleFillAddressData = (data) => {
    if (data.city) {
      this.elements.city.value = data.city;
    }

    if (data.town) {
      this.elements.address01.value = data.town;
    }

    if (data.prefecture) {
      this.elements.province.value = this._getPrefectureByName(data.prefecture);
    }
    this.elements.address01.focus();
  };

  _callAutoFillZipCodeApi = (zipCode) => {
    return fetch("https://api.kenall.jp/v1/postalcode/" + zipCode, {
      method: "GET",
      headers: {
        Authorization: "Token " + this.apiKey,
      },
      dataType: "json",
      timeout: 6000,
    });
  };

  _toZipCodeString = (value) => {
    return value
      .replace(/−/g, "")
      .replace(/-/g, "")
      .replace(/ー/g, "")
      .replace(/[０-９]/g, function (char) {
        return String.fromCharCode(char.charCodeAt(0) - 0xfee0);
      });
  };

  /**
   * prefecture[0], element[0] = prefectureID
   * prefecture[1] = prefectureName
   * prefecture[2] = prefectureValue - Checkout
   */
  _getPrefectureByName = (searchName) => {
    let element = null;
    if(this.options.name === "register"){
      element =
      this.prefectures.find((prefecture) => {
        return prefecture[0] === searchName;
      }) || null;
    }else{
      element =
      this.prefectures.find((prefecture) => {
        return prefecture[1] === searchName;
      }) || null;
    }

    if (this.options.name === "checkout") {
      return element ? element[2] : this.prefectures[0][2];
    }

    return element ? element[0] : this.prefectures[0][0];
  };

  /**
   * ボタン上のエラー表示
   */
  _displayError = (thisButton) =>  {
    let errorMessageId = this.elements.form.querySelector('#error_message');
    if(this.options.name === "addresses"){
      if(!errorMessageId){
        let errorMessage = document.createElement('p');
        errorMessage.innerText = '入力内容に不備があります';
        errorMessage.className = 'error-message';
        errorMessage.id = 'error_message';
        thisButton.parentNode.before(errorMessage);
      }
    }
  };

  /* フリガナ表示制御 */
  _furiganaDisplay = (furigana, lastKana, firstKana) => {
    let firstLang = WOVN.io.getCurrentLang().code;
    if(firstLang == 'ja'){
      furigana.style.display = 'flex';
      lastKana.setAttribute('required', true);
      firstKana.setAttribute('required', true);
    }else{
      furigana.style.display = 'none';
      lastKana.removeAttribute('required');
      firstKana.removeAttribute('required');
    }
  }
}